<mat-spinner diameter=32 strokeWidth=2></mat-spinner>
